import { ISnookerTable } from "../../types/ISnookerTable";
import { ISnookerData } from "./ISnookerData";

let data: ISnookerTable[] = [];
let selectedTable: ISnookerTable;

export class SnookerData implements ISnookerData {
  public setData(d: ISnookerTable[]): void {
    data = d;
  }
  getData(): ISnookerTable[] {
    return data;
  }
  public setSelected(data: ISnookerTable): void {
    selectedTable = data;
  }
  getSelected(): ISnookerTable {
    return selectedTable;
  }
}
